// Hero Carousel Data
export const heroSlides = [
  {
    id: 1,
    title: 'Building Your Dreams Into Reality',
    subtitle: 'Building Excellence Since 2014',
    description: 'Delivering quality construction solutions including Kerala government works and private sector projects with over 20+ successful completions.',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=2000&q=85&auto=format&fit=crop',
  },
  {
    id: 2,
    title: 'Kerala Government Projects',
    subtitle: 'Proven Track Record',
    description: 'Specialized in government infrastructure projects across Kerala, combining experience with innovation to deliver exceptional results.',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=2000&q=85&auto=format&fit=crop',
  },
  {
    id: 3,
    title: 'Your Vision, Our Mission',
    subtitle: 'A Decade of Excellence',
    description: 'Over 10 years of collaborative construction expertise ensuring your project goals are met with precision and care.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=2000&q=85&auto=format&fit=crop',
  },
  {
    id: 4,
    title: 'Quality You Can Trust',
    subtitle: '20+ Projects Delivered',
    description: 'Committed to superior craftsmanship and sustainable building practices with proven success across Kerala.',
    image: 'https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=2000&q=85&auto=format&fit=crop',
  },
];

// Hero Configuration
export const heroConfig = {
  autoPlayInterval: 6000, // milliseconds
  transitionDuration: 1200, // milliseconds
};
